import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login.vue'
import FormList from '@/components/form_list.vue'
import PreparedUserList from '@/components/prepared_user_list.vue'
import MakeFormList from '@/components/make_form_list.vue'
import SelfScoreFormCreater from '@/components/self_score_form_creater.vue'
import ScoreFormCreater from '@/components/score_form_creater.vue'

import SelfScoreFormCreaterEx from '@/components/self_score_form_creater_ex.vue'
import ScoreFormCreaterEx from '@/components/score_form_creater_ex.vue'

import SatisfyFormCreater from '@/components/satisfy_form_creater.vue'
import SatisfyFormCreaterEx from '@/components/satisfy_form_creater_ex.vue'

import ImportExcelFromTemplate from '@/components/import_excel_from_template.vue'

import DimensionScoreFormCreaterEx from '@/components/dimension_score_form_creater_ex.vue'
import DimensionScoreFormCreater from '@/components/dimension_score_form_creater.vue'



// import ImportDataExcel from '@/components/import_data_excel.vue'
// import SetformCondition from '@/components/set_form_condition.vue'

// import Registe from '@/components/registe.vue'
// import UserForm from '@/components/user_form.vue'
// import ImportExcel from '@/components/import_excel.vue'
// import ExcelPreview from '@/components/excel_preview.vue'
// import MakeForm from '@/components/make_form.vue'
// import ReadMe from '@/components/read_me.vue'

// import TableView from '@/components/tableView.vue'

// // 核对数据表
// import ValidationFormList from '@/components/validation_form_list.vue'

// import ExcelDataPreview from '@/components/excel_data_preview.vue'
// import ExcelDataImportFinalStep from '@/components/excel_data_import_final_step.vue'
// import InputerList from '@/components/inputer_list.vue'
// import InputerListDetail from '@/components/inputer_list_detail.vue'

// import FormDetail from '@/components/form_detail.vue'

// import BrowseAllData from '@/components/browse_all_data.vue'
// import AddRecord from '@/components/add_record.vue'

// import InvitedFormList from '@/components/invited_form_list.vue'

// import ResetformConditions from '@/components/reset_form_conditions.vue'


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    },
    {
      path: '/form_list',
      name: 'formList',
      component: FormList,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    },
    {
      path: '/prepared_user_list',
      name: 'prepared_user_list',
      component: PreparedUserList,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    },
    {
      path: '/make_form_list',
      name: 'make_form_list',
      component: MakeFormList,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/self_score_form_creater',
      name: 'self_score_form_creater',
      component: SelfScoreFormCreater,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/score_form_creater',
      name: 'score_form_creater',
      component: ScoreFormCreater,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/self_score_form_creater_ex',
      name: 'self_score_form_creater_ex',
      component: SelfScoreFormCreaterEx,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/score_form_creater_ex',
      name: 'score_form_creater_ex',
      component: ScoreFormCreaterEx,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/satisfy_form_creater',
      name: 'satisfy_form_creater',
      component: SatisfyFormCreater,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/satisfy_form_creater_ex',
      name: 'satisfy_form_creater_ex',
      component: SatisfyFormCreaterEx,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/import_excel_from_template',
      name: 'import_excel_from_template',
      component: ImportExcelFromTemplate,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }, {
      path: '/dimension_score_form_creater_ex',
      name: 'dimension_score_form_creater_ex',
      component: DimensionScoreFormCreaterEx,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    },
    {
      path: '/dimension_score_form_creater',
      name: 'dimension_score_form_creater',
      component: DimensionScoreFormCreater,
      meta: {
        title: '绩效考核、互评自评，自动计算，自动汇总'
      }
    }



  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js